import * as React from 'react';
import { SVGIcon, SVGIconProps } from '../SvgIcon';

export let FileIcon = (props: SVGIconProps) => (
    <SVGIcon viewBox="0 0 12 15" width="10" {...props}>
        <path d="M3.5,13.5h9v-9h-3v-3h-6ZM2,14.25V0h9l3,3V15H2Z" transform="translate(-2)" />
    </SVGIcon>
);
